var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlOutlineFilled = function SvgHtlOutlineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlOutlineFilled_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlOutlineFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.021 15.073a7.01 7.01 0 0 1-3.618-1.725l-.609.61a.5.5 0 0 1-.854-.355v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .353.853l-.683.683a6.023 6.023 0 0 0 3.067 1.447 6.02 6.02 0 0 0 4.51-1.08 6.1 6.1 0 0 0 2.3-6.442.5.5 0 1 1 .967-.254 7.057 7.057 0 0 1-.164 4.117 7.017 7.017 0 0 1-2.52 3.388 7 7 0 0 1-5.249 1.258Zm.48-3.165v-.84a3.946 3.946 0 0 1-1.652-.547.5.5 0 0 1 .53-.847 2.85 2.85 0 0 0 1.122.384V8.285a2.245 2.245 0 0 1-1.665-1.29 1.652 1.652 0 0 1 .382-1.537c.354-.341.8-.572 1.282-.666v-.71a.5.5 0 0 1 1 0v.691c.113.015.228.037.345.064a4.6 4.6 0 0 1 1.311.534.5.5 0 0 1-.537.843 3.63 3.63 0 0 0-1.024-.409l-.094-.019v1.72c.225.066.444.15.655.25a1.776 1.776 0 0 1 1.218 1.718 1.556 1.556 0 0 1-.92 1.29c-.3.149-.621.247-.953.29v.853a.5.5 0 0 1-1 0v.001Zm1-1.87a1.86 1.86 0 0 0 .5-.163.586.586 0 0 0 .379-.462c.025-.4-.441-.68-.875-.85l-.004 1.474Zm-1.57-3.876a.666.666 0 0 0-.14.53c.033.1.168.325.71.536v-1.4c-.212.07-.406.183-.57.334Zm-5.76 3.625a7.04 7.04 0 0 1 .165-4.117 7.013 7.013 0 0 1 2.52-3.389A7.014 7.014 0 0 1 9.11 1.023a7.017 7.017 0 0 1 3.618 1.726l.609-.609a.5.5 0 0 1 .854.354v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.354-.854l.683-.682a6.015 6.015 0 0 0-3.066-1.446 6.015 6.015 0 0 0-4.511 1.08 6.1 6.1 0 0 0-2.3 6.442.5.5 0 0 1-.484.627.5.5 0 0 1-.487-.374Z"
  }))));
};
export default SvgHtlOutlineFilled;